import React, { useEffect, useState, useRef } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
// import careerConnectLogo from "../../assets/logo.svg";
import Toast from "../Common/ReactToastifyNotification/Toastify";
import apiService from "../../service";
import VerificationIcon from "../../assets/Verification.png";
import "./Signup.css";
import DrawerLogo from "../../assets/DrawerLogo.png";

function VerificationId() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isVerified, setIsVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // useRef to prevent double API call
  const hasCalled = useRef(false);

  useEffect(() => {
    // Check if already verified
    const verifiedStatus = localStorage.getItem("isVerified");
    if (verifiedStatus === "true") {
      navigate("/");
      return;
    }

    if (hasCalled.current || !id) return;
    hasCalled.current = true;

    const verifyUser = async () => {
      try {
        setIsLoading(true);
        const response = await apiService.verificationValid({
          verificationId: id,
        });
        // Accept both boolean true and string "true" from backend
        if (
          response?.status === true ||
          response?.status === "true" ||
          response?.data?.is_verified === true ||
          response?.data?.is_verified === "true"
        ) {
          Toast.success({
            message: response.message,
          });
          setIsVerified(true);
          const {
            token,
            name,
            isVerified,
            email: userEmail,
            verificationId,
            _id,
            refreshToken,
            tenantId,
            apiKey,
            // message,
            role,
          } = response.data || {};
          setIsVerified(true);
          localStorage.setItem("token", token || "");
          localStorage.setItem("name", name || "");
          localStorage.setItem("isVerified", JSON.stringify(isVerified));
          localStorage.setItem("email", userEmail || "");
          localStorage.setItem("verificationId", verificationId || "");
          localStorage.setItem("_id", _id || "");
          localStorage.setItem("refreshToken", refreshToken || "");
          localStorage.setItem("tenantId", tenantId || "");
          localStorage.setItem("apiKey", apiKey || "");
          localStorage.setItem("role", role || "");
          const accessList = response?.data?.access_list || [];
          if (!Array.isArray(accessList)) {
            console.error("Invalid accessList format", accessList);
            navigate("/login");
            return;
          }
          localStorage.setItem("access", JSON.stringify(accessList));
          setTimeout(() => {
            if (accessList.includes("IDCriminalDocument")) {
              navigate("/my-ai/criminal-document");
            } else {
              navigate("/doc-ai/invoice");
            }
          }, 2000);
        }
      } catch (error) {
        console.error("Verification error:", error);
        Toast.error({
          message:
            error.response?.data?.message ||
            "Something went wrong. Please try again.",
        });
        setTimeout(() => navigate("/login"), 2000);
      } finally {
        setIsLoading(false);
      }
    };

    verifyUser();
    // run only once on mount
  }, [id, navigate]);

  return (
    <Box className="mains-container">
      {/* Left Image Section */}
      <Box className="image-container">
        {/* <img src={SignupBg} alt="Background" className="background-image" />
         */}
        <div className="bg-logo"></div>
      </Box>

      {/* Right Verification Section */}
      <Box className="right-container">
        <Box className="verification-box">
          <div>
            <img src={DrawerLogo} alt="Logo" className="Dlogo" />
          </div>
          <div>
            <img
              src={VerificationIcon}
              alt="Verification Email"
              className="verification-icon"
            />
          </div>
          <Typography
            variant="h5"
            sx={{
              fontSize: "26px",
              fontWeight: "bold",
              color: "#000000",
              mb: 1,
              fontFamily: "Inter",
              textAlign: "center",
            }}
          >
            {isLoading
              ? "Verifying your account"
              : isVerified
              ? "Verification successful!"
              : "Verification failed"}
          </Typography>

          <Typography
            sx={{
              fontSize: "14px",
              mb: 2,
              textAlign: "center",
              color: "#969696",
              fontFamily: "Inter",
            }}
          >
            {isLoading
              ? "Please wait while we verify your identity..."
              : isVerified
              ? "Redirecting you to your dashboard..."
              : "Redirecting to login page..."}
          </Typography>

          {isLoading && (
            <Box display="flex" justifyContent="center" mt={2}>
              <CircularProgress size={24} color="inherit" />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default VerificationId;
